<template>
  <div>
    <div class="col-md-6 col-sm-12 col-xs-12 call-info"><b>Số điện thoại:</b> {{callRecord.dest_number}}</div>
    <div class="col-md-6 col-sm-12 col-xs-12 call-info"><b>Ngày thực hiện:</b> {{callRecord.calldate | format_date}}</div>
    <div class="col-md-6 col-sm-12 col-xs-12 call-info"><b>Loại cuộc gọi:</b> {{callRecord.direction === 'incoming' ? 'Cuộc gọi đến' : 'Cuộc gọi đi'}}</div>
    <div class="col-md-6 col-sm-12 col-xs-12 call-info"><b>Thời gian gọi:</b> {{convertSecondToMMSS(callRecord.duration)}}</div>
    <audio controls autoplay>
      <source :src="callRecord.record_url" type="audio/mp3">
      Your browser does not support the audio tag.
    </audio>
  </div>
</template>

<script>
import Utils from '../common/utils'

export default {
  name: 'CallRecord',
  props: {
    callRecord: {
      type: Object,
      required: true
    },
  },
  methods: {
    convertSecondToMMSS (second) {
      return Utils.convertSecondToMMSS(second)
    }
  },
}
</script>

<style scoped>
  audio {
    margin-top: 20px;
    width: 100%;
  }
  .call-info {
    padding: 10px 0;
    font-size: 16px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/CallRecord.vue